import { useState } from "react";
import { Button } from "./ui";
import { usePlayer, eventQueue } from "../lib/player";
import { exportSetlistPdf } from "../lib/pdf";
import { api, EVENT_LABEL } from "../lib/api";

const typeLabel = (t) => EVENT_LABEL[t] || "Evento";

/** The event's official order with each song resolved to the member's voice by the server (fallback: event songs). */
export const studyQueue = async (event) => {
  try {
    const q = await api(`/events/${event.id}/study-queue`);
    return q.map((x) => ({ song_id: x.song_id, title: x.title, artist: x.artist, cover_url: x.cover_url, voice: x.fallback ? undefined : x.part?.voice }));
  } catch (err) {
    console.error("study-queue indisponível; a usar o alinhamento do evento", err);
    return eventQueue(event);
  }
};

/** "Estudar alinhamento": plays the event's official setlist in order, in the member's voice (server study-queue). */
export function StudySetlistButton({ event, testid, className = "auto sm" }) {
  const player = usePlayer();
  const [busy, setBusy] = useState(false);
  if (!event?.songs?.length || event.can_study === false) return null;
  const start = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBusy(true);
    const items = await studyQueue(event).finally(() => setBusy(false));
    if (items.length) player.playQueue(items, 0, { key: `event:${event.id}`, label: `Alinhamento · ${event.title || ""}`, path: `/events/${event.id}` });
  };
  return <Button className={className} icon="play" loading={busy} onClick={start} data-testid={testid || `study-setlist-${event.id}`}>ESTUDAR ALINHAMENTO</Button>;
}

export function SetlistPdfButton({ event, testid }) {
  if (!event?.songs?.length) return null;
  return <Button className="auto sm ghost" icon="download" onClick={() => exportSetlistPdf(event, typeLabel)} data-testid={testid || `setlist-pdf-${event.id}`}>PDF</Button>;
}
